import axios from 'axios'
import { environment } from '@/data/environment/'
import { refreshToken } from '@/auth/refreshJwt'

export default {
  namespaced: true,
  state: {
    listParametros: [],
    parametrosByGrupo: [],
    updateStatusResponse: false,
  },

  getters: {
    // Obtener grupos únicos con contador
    gruposAgrupados: (state) => {
      const gruposMap = {}
      state.listParametros.forEach(param => {
        if (!gruposMap[param.group]) {
          gruposMap[param.group] = {
            nombre: param.group,
            total: 0,
            editables: 0,
          }
        }
        gruposMap[param.group].total++
        if (param.editable) gruposMap[param.group].editables++
      })
      return Object.values(gruposMap)
    },
  },

  mutations: {
    setListParametros (state, data) {
      state.listParametros = data
    },
    setParametrosByGrupo (state, data) {
      state.parametrosByGrupo = data
    },
    setUpdateResponse (state, data) {
      state.updateStatusResponse = data
    },
  },

  actions: {
    // Obtener todos los parámetros
    async getListParametros ({ commit }) {
      const endpoint = '/getParametros'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      const user = JSON.parse(atob(localStorage.getItem('uid')))

      try {
        const response = await axios.create({
          headers: { Authorization: `Bearer ${user.jwt}` },
        }).get(url)

        if (response.data.respuesta?.Mensaje === 'token_invalid') {
          await refreshToken()
          const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
          const newResponse = await axios.create({
            headers: { Authorization: `Bearer ${newJwt}` },
          }).get(url)
          commit('setListParametros', newResponse.data.respuesta.Datos)
        } else {
          commit('setListParametros', response.data.respuesta.Datos)
        }
      } catch (error) {
        console.log('Error al obtener parámetros:', error.message)
      }
    },

    // Obtener parámetros por grupo
    getParametrosByGrupo ({ commit, state }, grupo) {
      const filtrados = state.listParametros.filter(p => p.group === grupo)
      commit('setParametrosByGrupo', filtrados)
    },

    // Actualizar parámetro
    async updateParametro ({ commit }, data) {
      const endpoint = '/updateParametros'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      const user = JSON.parse(atob(localStorage.getItem('uid')))

      const payload = {
        id: data.id,
        valor: data.valor,
        usuario: user.username,
      }

      try {
        const response = await axios.create({
          headers: { Authorization: `Bearer ${user.jwt}` },
        }).put(url, payload)

        if (response.data.respuesta?.Mensaje === 'token_invalid') {
          await refreshToken()
          const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
          const newResponse = await axios.create({
            headers: { Authorization: `Bearer ${newJwt}` },
          }).put(url, payload)
          commit('setUpdateResponse', newResponse.data.respuesta?.Error === false || newResponse.status === 200)
        } else {
          commit('setUpdateResponse', response.data.respuesta?.Error === false || response.status === 200)
        }
      } catch (error) {
        console.log('Error al actualizar parámetro:', error.message)
        commit('setUpdateResponse', false)
      }
    },

    resetUpdateResponse ({ commit }) {
      commit('setUpdateResponse', false)
    },
  },
}
